import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
  import { useStore } from "vuex";
  import { useToast } from "vue-toastification";
  import { useRouter } from "vue-router";
  import dayjs from "dayjs";
  import { EstateInterface } from "@/types/EstateInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminReports',
  setup(__props, { expose: __expose }) {
  __expose();

  const clock = ref(dayjs().format("h:mm A"));
  const interval = ref();

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);
  const router = useRouter();

  const estates = ref<EstateInterface[]>([]);

  const getEstates = async () => {
    loading.value = true;

    try {
      const res = await store.dispatch("estate/getEstates");

      estates.value = res.data;
      loading.value = false;
    } catch (error) {
      toast.error("Error getting estates");
    }
  };

  const goToEstateGraph = (estate: EstateInterface) => {
    router.push({
      name: "EstateGraphs",
      params: { stateId: estate._id },
    });
  };

  onMounted(() => {
    getEstates();
  });

  onMounted(() => {
    interval.value = setInterval(() => {
      clock.value = dayjs().format("h:mm A");
    }, 1000);
  });

const __returned__ = { clock, interval, store, toast, loading, router, estates, getEstates, goToEstateGraph, ref, onMounted, get useStore() { return useStore }, get useToast() { return useToast }, get useRouter() { return useRouter }, get dayjs() { return dayjs }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})